// Shoppable story player for amaji-story-bubbles.
//
// Deliberately dependency-free and lazy: the section ships only poster thumbnails, and the
// first <video> is created when a bubble is tapped. One player element is reused for every
// story rather than one per bubble.
//
// Controls follow what people already know from Instagram: right half advances, left half goes
// back, Escape or the X closes, a downward swipe closes, and the progress bars track the clip.
(() => {
  const section = document.querySelector('[data-amaji-stories]');
  if (!section) return;

  const data = (() => {
    const tag = section.querySelector('[data-amaji-stories-data]');
    try { return JSON.parse(tag.textContent); } catch { return []; }
  })();
  if (!data.length) return;

  let player;
  let index = 0;
  let raf = 0;
  let fallback = 0;

  function build() {
    player = document.createElement('div');
    player.className = 'amaji-story-player';
    player.innerHTML = `
      <div class="amaji-story-player__stage">
        <div class="amaji-story-player__bars"></div>
        <p class="amaji-story-player__title"></p>
        <button class="amaji-story-player__close" type="button" aria-label="Close">&times;</button>
        <video class="amaji-story-player__video" playsinline muted autoplay></video>
        <div class="amaji-story-player__nav">
          <button type="button" aria-label="Previous"></button>
          <button type="button" aria-label="Next"></button>
        </div>
        <div class="amaji-story-player__shop"></div>
      </div>`;
    document.body.appendChild(player);

    const [prev, next] = player.querySelectorAll('.amaji-story-player__nav button');
    prev.addEventListener('click', () => go(index - 1));
    next.addEventListener('click', () => go(index + 1));
    player.querySelector('.amaji-story-player__close').addEventListener('click', close);
    player.querySelector('video').addEventListener('ended', () => go(index + 1));

    // Swipe down to dismiss, the gesture the format trained everyone to expect.
    let startY = null;
    player.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; }, { passive: true });
    player.addEventListener('touchend', (e) => {
      if (startY !== null && e.changedTouches[0].clientY - startY > 70) close();
      startY = null;
    });
  }

  function bars() {
    const wrap = player.querySelector('.amaji-story-player__bars');
    wrap.innerHTML = data.map((_, i) =>
      `<span class="amaji-story-player__bar${i < index ? ' amaji-story-player__bar--done' : ''}"><i></i></span>`).join('');
    return wrap.children[index]?.firstElementChild;
  }

  function go(next) {
    if (next < 0) return;
    if (next >= data.length) return close();
    index = next;
    render();
  }

  function render() {
    const story = data[index];
    const video = player.querySelector('video');
    const fill = bars();

    player.querySelector('.amaji-story-player__title').textContent = story.title || '';
    video.poster = story.poster || '';
    video.src = story.video || '';
    video.currentTime = 0;
    video.muted = true;          // belt and braces: autoplay is only allowed while muted
    video.playsInline = true;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});

    // If the browser refuses to autoplay, the story must still advance rather than freeze on
    // a poster. Fall back to a fixed dwell so the sequence always finishes.
    clearTimeout(fallback);
    fallback = setTimeout(() => { if (video.paused) go(index + 1); }, 6000);

    player.querySelector('.amaji-story-player__shop').innerHTML = (story.products || []).map((p) => `
      <a class="amaji-story-player__chip" href="${p.url}">
        ${p.image ? `<img src="${p.image}" alt="" width="38" height="38">` : ''}
        <span><b>${p.title}</b><span>${p.price}</span></span>
      </a>`).join('');

    cancelAnimationFrame(raf);
    const tick = () => {
      if (fill && video.duration) fill.style.width = `${Math.min(100, (video.currentTime / video.duration) * 100)}%`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
  }

  function open(i) {
    if (!player) build();
    index = i;
    player.setAttribute('data-open', '');
    document.documentElement.style.overflow = 'hidden';
    render();
  }

  function close() {
    cancelAnimationFrame(raf);
    clearTimeout(fallback);
    const video = player.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    player.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
  }

  section.querySelectorAll('[data-amaji-story]').forEach((button) => {
    button.addEventListener('click', () => open(Number(button.dataset.amajiStory) || 0));
  });

  document.addEventListener('keydown', (e) => {
    if (!player || !player.hasAttribute('data-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') go(index + 1);
    if (e.key === 'ArrowLeft') go(index - 1);
  });
})();
